import React, { useState } from "react"
import { motion } from "framer-motion"
import SocialMedia from "./SocialMedia"

export default function Contact() {
  const [sent, setSent] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    setSent(true)
  }

  return (
    <section id="contact" className="bg-ink text-white border-t border-lineSoft py-20 sm:py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex items-baseline gap-3.5 mb-10">
          <span className="font-mono text-xs text-amber">05</span>
          <h2 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight">Ground control</h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5 }}
          className="grid md:grid-cols-2 border border-line bg-panel"
        >
          <div className="p-8 sm:p-10 border-b md:border-b-0 md:border-r border-line">
            <h3 className="font-display font-semibold text-xl mb-3">Let's talk</h3>
            <p className="text-muted text-sm max-w-xs mb-8">
              Open to opportunities in IT operations, systems support and backend development.
              Reach out directly — I usually reply within a day.
            </p>
            <SocialMedia />
          </div>

          <div className="p-8 sm:p-10">
            {sent ? (
              <div className="h-full flex flex-col justify-center">
                <p className="font-mono text-xs text-mint mb-2">● MESSAGE NOTED</p>
                <p className="text-muted text-sm">
                  Thanks for reaching out. This form doesn't send automatically yet — for a
                  guaranteed reply, please email{" "}
                  <a href="mailto:dineshkhawas123@gmail.com" className="text-amber hover:underline">
                    dineshkhawas123@gmail.com
                  </a>{" "}
                  directly.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="name" className="font-mono text-[11px] text-muted2 tracking-wide">
                    NAME
                  </label>
                  <input
                    id="name"
                    placeholder="Your name"
                    required
                    className="bg-panel2 border border-line px-3.5 py-2.5 text-sm text-white placeholder:text-muted2 focus:outline-none focus:border-amber transition-colors"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="email" className="font-mono text-[11px] text-muted2 tracking-wide">
                    EMAIL
                  </label>
                  <input
                    id="email"
                    type="email"
                    placeholder="you@example.com"
                    required
                    className="bg-panel2 border border-line px-3.5 py-2.5 text-sm text-white placeholder:text-muted2 focus:outline-none focus:border-amber transition-colors"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="message" className="font-mono text-[11px] text-muted2 tracking-wide">
                    MESSAGE
                  </label>
                  <textarea
                    id="message"
                    placeholder="What are you looking to build?"
                    required
                    rows={4}
                    className="bg-panel2 border border-line px-3.5 py-2.5 text-sm text-white placeholder:text-muted2 focus:outline-none focus:border-amber transition-colors resize-none"
                  />
                </div>
                <button
                  type="submit"
                  className="mt-2 font-mono text-sm tracking-wide border border-amber text-amber px-6 py-3 hover:bg-amber hover:text-ink transition-colors self-start"
                >
                  Send message
                </button>
              </form>
            )}
          </div>
        </motion.div>
      </div>

      <p className="text-center font-mono text-[11px] text-muted2 mt-16">
        DINESH B. KHAWAS — POKHARA, NEPAL
      </p>
    </section>
  )
}
